export default __webpack_public_path__ + "static/B0177-604c95bde43360cd3cd448c08d0db3c9.png";